export default "__VITE_ASSET__DkC9W6eO__"